module.exports = __webpack_public_path__ + "img/load.c4059b60.svg";